
import { defineComponent, reactive, ref } from "vue";
import ScrollItem from "./ScrollItem.vue";
export default defineComponent({
  components: { ScrollItem },
  setup() {
    const imgList = [
      {imgUrl: "https://ecompic2.hitv.com/business/3/20260722151434871.png", title: "首页",},
      {imgUrl: "https://ecompic2.hitv.com/business/3/20260722151341563.png", title: "来玩",},
      {imgUrl: "https://ecompic2.hitv.com/business/3/20260722151416282.png", title: "去现场",},
      {imgUrl: "https://ecompic2.hitv.com/business/3/20260722151304507.png", title: "官方周边",},
      {imgUrl: "https://ecompic2.hitv.com/business/3/20260722151452101.png", title: "兴趣圈层",},
      {imgUrl: "https://ecompic2.hitv.com/business/3/20260722151511472.png", title: "子频道-EDC",},
      {imgUrl: "https://ecompic2.hitv.com/business/3/20260722151528101.png", title: "子频道-二次元",},
      {imgUrl: "https://ecompic2.hitv.com/business/3/20260722151606810.png", title: "子频道-机甲",},
      {imgUrl: "https://ecompic2.hitv.com/business/3/20260722151546874.png", title: "子频道-咕噜比",},
      {imgUrl: "https://ecompic2.hitv.com/business/3/20260722151628683.png", title: "子频道-南波万",},
    ];
    let stripeTransform = reactive([
      {
        paddingTop: 380,
        top: 0,
        scale: 1,
      },
      {
        paddingTop: 100,
        top: 0,
        scale: 0.8,
      },
      {
        paddingTop: 260,
        top: 0,
        scale: 0.9,
      },
    ]);

    const scroll$ = ref<HTMLDivElement>();
    // window.addEventListener("scroll", () => {
    //   const top = scroll$.value?.getBoundingClientRect().top || 0;
    // if (top < 0) {
    //   stripeTransform.forEach((v) => {
    //     v.top = top * v.scale;
    //   });
    // } else {
    //   stripeTransform.forEach((v) => {
    //     v.top = 0;
    //   });
    // }
    // });

    return {
      stripeTransform,
      scroll,
      imgList,
      scroll$,
    };
  },
});
